"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ScrollDetector = /** @class */ (function (_super) {
    __extends(ScrollDetector, _super);
    function ScrollDetector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        Object.defineProperty(_this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                scrollPosition: document.documentElement.scrollTop,
            }
        });
        Object.defineProperty(_this, "componentDidMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                document.addEventListener('scroll', _this.handleScroll);
            }
        });
        Object.defineProperty(_this, "componentWillUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                document.removeEventListener('scroll', _this.handleScroll);
            }
        });
        Object.defineProperty(_this, "handleScroll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var scrollPosition = _this.state.scrollPosition;
                var scrollTop = document.documentElement.scrollTop;
                var isBottom = false;
                if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
                    isBottom = true;
                }
                var scrollDirection = 'DOWN';
                if (scrollPosition && scrollPosition > scrollTop) {
                    scrollDirection = 'UP';
                }
                _this.props.onScroll(scrollTop, scrollDirection, isBottom);
                _this.setState({
                    scrollPosition: scrollTop,
                });
            }
        });
        return _this;
    }
    Object.defineProperty(ScrollDetector.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return null;
        }
    });
    return ScrollDetector;
}(react_1.default.Component));
exports.default = ScrollDetector;
